export enum OpportunityState {
    UnderReview = 'UnderReview',
    Rejected = 'Rejected',
    Active = 'Active',
    Expired = 'Expired',
    Canceled = 'Canceled'
}